import { t } from "@lingui/core/macro"
import { CAUTION_PASSWORD } from "../constants"
import styles from "./MessageRowDisclaimer.module.scss"

type Props = {
    username: string
}

export const MessageRowDisclaimer: React.FC<Props> = ({ username }) => {
    return (
        <div className={styles.messageRowDisclaimer} data-testid="notices">
            <div
                className={styles.messageRowNotice}
            >{t`Private conversation with ${username}`}</div>
            <div className={styles.messageRowNotice}>{t(CAUTION_PASSWORD)}</div>
        </div>
    )
}
